module.exports = __webpack_public_path__ + "static/img/极氪009.6fefd19e.png";